export default __webpack_public_path__ + "static/media/biscuit-white.7a61a3bc.png";